import React from "react";
import { EditProductRootScreenContext } from "./context";

export const useEditProductRootScreenContextProvider = () => {
  const context = React.useContext(EditProductRootScreenContext);
  if (!context) {
    throw new Error("No EditProductRootScreenContext context was provided.");
  }
  return context;
};
